module.exports = __webpack_public_path__ + "img/usa-flag.936feee6.svg";